import PropTypes from 'prop-types'

import Icon from '../../Icons'

const SettingsSidebar = ({ currentRole, showSettings, showChat }) => (
  <div className={'settings__sidebar'}>
    <div>
      <div className="action-button" onClick={showChat}>
        <Icon icon="message" viewBox="2 0 28 28" />
      </div>
    </div>
    {!['Staff', 'ShiftManager'].includes(currentRole) && (
      <div className="action-button" onClick={showSettings}>
        <Icon icon="settings" viewBox="0 0 24 24" />
      </div>
    )}
  </div>
)

SettingsSidebar.propTypes = {
  currentRole: PropTypes.string,
  showSettings: PropTypes.func,
  showChat: PropTypes.func,
}

export default SettingsSidebar
